import { Fragment, useState } from "react";
import { Link } from "react-router-dom";

export default function JugadorSeasonHighsPanel({ highs = [], className = "" }) {
    const [expanded, setExpanded] = useState(null);

    return (
        <section className={`rounded-xl border border-white/10 bg-[#102216] overflow-hidden h-fit ${className || "mb-12"}`}>
            <div className="px-5 py-4 border-b border-white/10 bg-white/5 text-center">
                <h3 className="text-sm font-bold text-green-500 uppercase tracking-wider">Máximos</h3>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <tbody className="divide-y divide-white/10">
                        {highs.map((item) => {
                            const partidos = item.partidos || [];
                            const partidosToShow = partidos.slice(0, 3);
                            const isExpanded = expanded === item.label;
                            const partidosLabel = partidos.length > 3 ? "3+ partidos" : `${partidos.length} partidos`;

                            return (
                                <Fragment key={item.label}>
                                    <tr className="hover:bg-white/5 text-slate-200">
                                        <td className="px-3 sm:px-4 py-2 font-medium text-slate-400 whitespace-nowrap">{item.label}</td>
                                        <td className="px-2 sm:px-4 py-2 text-center font-bold">{item.value || "-"}</td>
                                        <td className="px-3 sm:px-4 py-2 text-right text-xs text-slate-500">
                                            {partidos.length === 1 ? (
                                                <Link className="text-slate-400 hover:text-green-300" to={`/partido/${partidos[0].partidoId}`}>
                                                    {partidos[0].liga} vs {partidos[0].adversario?.slice(0, 3).toUpperCase()}
                                                </Link>
                                            ) : partidos.length > 1 ? (
                                                <button
                                                    className="text-slate-400 hover:text-green-300 cursor-pointer"
                                                    onClick={() => setExpanded(isExpanded ? null : item.label)}
                                                >
                                                    {partidosLabel} {isExpanded ? "▲" : "▼"}
                                                </button>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                    </tr>
                                    {isExpanded && partidosToShow.map((partido, idx) => (
                                        <tr key={`${item.label}-${idx}`} className="bg-white/5 text-slate-200">
                                            <td colSpan={2} />
                                            <td className="px-3 sm:px-4 py-1.5 text-right text-xs">
                                                <Link className="text-green-400 hover:text-green-300" to={`/partido/${partido.partidoId}`}>
                                                    {partido.liga} vs {partido.adversario?.slice(0, 3).toUpperCase()}
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
